<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      :boundItemsUrl="boundItemsUrl"
      :collectionFilters="collectionFilters"
      :columns="columns"
      :inDetailsAsidePanel="true"
      :itemType="itemType"
      :linkText="applicationLinkText"
      :route="route"
      :showBound="false"
      :showSearchForm="true"
    />
  </div>
</template>
<script>
import {
  ItemTableConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import ApplicationFeatures from 'client/components/ItemTable/BodyComponents/ApplicationFeatures.vue';
import ApplicationTemplateLogo from 'client/components/ItemTable/BodyComponents/ApplicationTemplateLogo.vue';
import ApplicationTemplatesFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/ApplicationTemplatesFilters';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import PageNavigationUtil from 'client/util/PageNavigationUtil';

const { columnTypes } = ItemTableConsts;
const {
  applicationTemplate,
} = ItemTypeConsts;

export default {
  name: 'ApplicationTemplateItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
  ],

  props: {
    itemType: {
      type: String,
      default: applicationTemplate,
    },
  },

  data() {
    return {
      collectionFilters: [
        ApplicationTemplatesFilters.appStatusEos(),
        ApplicationTemplatesFilters.appStatusEol(),
      ],
      columns: [
        {
          classNames: {
            body: [columnTypes.selectColumn],
            heading: [columnTypes.selectColumn],
          },
        },
        {
          bodyComponent: ApplicationTemplateLogo,
          headingText: 'Name',
          sortBy: 'name',
        },
        {
          dataField: 'displayName',
        },
        {
          bodyComponent: ApplicationFeatures,
          headingText: 'Supported Functionality',
          bodyComponentProps: {
            itemType: this.itemType,
          },
        },
        {
          classNames: {
            body: ['applicationTemplateConfigureButton'],
          },
          bodyComponent: 'PolicyTemplateConfigureButton',
          bodyComponentProps: {
            handleClick: this.handleConfigureClick,
            buttonText: 'configure',
          },
        },
      ],
      applicationLinkText: 'Applications',
      route: ItemTypeRoutes[this.itemType],
    };
  },

  methods: {
    handleConfigureClick(item) {
      PageNavigationUtil.setLocation(`${this.route}/configure/${item.id}`);
    },
  },
};
</script>
